import { useEffect, useState } from "react";
import { useLoaderData, Link } from "react-router-dom";
import { CRow, CCol, CCard, CCardBody, CCardHeader, CButton } from '@coreui/react';
import { 
    FaChartLine, 
    FaShoppingCart, 
    FaBoxOpen, 
    FaTags, 
    FaNewspaper, 
    FaUsers 
} from "react-icons/fa";
import AxiosInstance from "src/components/Axios";

const urlApi = "/options";


export async function LoaderHome({ params }) {
    const role = localStorage.getItem('user_role');
    const tokenStr = localStorage.getItem('user')
    const header = { headers: { Authorization: `Bearer ${tokenStr}`, accept: 'application/json' } }

    if (role && role !== "ROLE_ADMIN") return { data: null };

    const requestParams = {
        option_key: "tehnical_links",
    };

    try {
        const response = await AxiosInstance(urlApi, { params: requestParams, ...header });
        // console.log('response', response);
        return { data: response.data[0] };
    } catch (error) {
        console.error("Помилка запиту за 'Технічними посиланнями':", error);
        return { data: null };
    };
};


const Home = () => {
    const { data } = useLoaderData();
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const tokenStr = localStorage.getItem('user');
                const response = await AxiosInstance.get('/dashboard/stats', {
                    headers: { Authorization: `Bearer ${tokenStr}` }
                });
                setStats(response.data);
            } catch (error) {
                console.error("Помилка отримання статистики:", error);
            }
        };
        fetchStats();
    }, []);

    const dashboardItems = [
        { title: "Клієнти", icon: <FaChartLine size={30} className="text-primary mb-3" />, link: "/statistics", desc: "Статистика та звіти", color: "primary", count: stats?.accounts, unit: "осіб" },
        { title: "Замовлення", icon: <FaShoppingCart size={30} className="text-success mb-3" />, link: "/pre-orders", desc: "Управління замовленнями", color: "success", count: stats?.orders, unit: "шт.", subCount: stats ? { new: stats.orders_new, completed: stats.orders_completed } : null },
        { title: "Товари", icon: <FaBoxOpen size={30} className="text-warning mb-3" />, link: "/products", desc: "Список усіх товарів", color: "warning", count: stats?.products, unit: "шт." },
        { title: "Категорії", icon: <FaTags size={30} className="text-info mb-3" />, link: "/category", desc: "Структура каталогу", color: "info", count: stats?.categories, unit: "шт." },
        { title: "Новини", icon: <FaNewspaper size={30} className="text-danger mb-3" />, link: "/news", desc: "Блог та статті", color: "danger", count: stats?.news, unit: "статей" },
        { title: "Користувачі", icon: <FaUsers size={30} className="text-secondary mb-3" />, link: "/users", desc: "Адміністратори системи", color: "secondary", count: stats?.users, unit: "осіб" },
    ];

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="mb-0"><strong>Вітаємо у панелі керування!</strong></h4>
            </div>

            <CRow>
                {dashboardItems.map((item, index) => (
                    <CCol xs={12} sm={6} lg={4} key={index} className="mb-4">
                        <CCard className="h-100 shadow-sm border-0 text-center hover-elevate">
                            <CCardBody className="d-flex flex-column align-items-center justify-content-center p-4">
                                {item.icon}
                                <h5 className="card-title fw-bold mb-2">{item.title}</h5>
                                {stats !== null ? (
                                    <>
                                        <h3 className={`text-${item.color} fw-bolder mb-1`}>
                                            {item.count} <span className="fs-6 text-muted fw-normal">{item.unit}</span>
                                        </h3>
                                        {item.subCount && (
                                            <div className="d-flex justify-content-center gap-3 small text-muted mb-3">
                                                <span>Нових: <strong className="text-secondary">{item.subCount.new}</strong></span>
                                                <span>|</span>
                                                <span>Виконаних: <strong className="text-secondary">{item.subCount.completed}</strong></span>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className="spinner-border spinner-border-sm text-secondary mb-2" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                )}
                                <p className={`text-muted small ${item.subCount ? 'mb-4 mt-0' : 'mb-4 mt-2'}`}>{item.desc}</p>
                                <Link to={item.link} className="mt-auto text-decoration-none w-100">
                                    <CButton color={item.color} variant="outline" className="w-100 fw-semibold rounded-pill">
                                        Перейти
                                    </CButton>
                                </Link>
                            </CCardBody>
                        </CCard>
                    </CCol>
                ))}
            </CRow>

            {
                data && (
                    <div style={{ marginTop: "50px" }}>
                        <hr />
                        <div dangerouslySetInnerHTML={{ __html: data.data }}></div>
                    </div>
                )
            }
        </div>
    );
};

export default Home;